export const getOffersSelector = (state) => state.offer.offers
